import axios from 'axios';

const getAuthHeader = () => ({
  headers: {
    'Authorization': `Bearer ${localStorage.getItem('token')}`
  }
});

export const fetchBatches = async () => {
  const response = await axios.get('/api/orders/user_batches/', getAuthHeader());
  return {
    results: response.data || [],
    count: response.data?.length || 0
  };
};

export const fetchBatchOrders = async (batchId) => {
  const response = await axios.get(`/api/orders/batches/${batchId}/orders/`, getAuthHeader());
  return response.data;
};

export const deleteBatch = async (batchId) => {
  await axios.delete(`/api/orders/batches/${batchId}/`, getAuthHeader());
};

export const createBulkBatch = async (batchNumber, orderIds, customerId) => {
  const response = await axios.post('/api/orders/batches/bulk/', {
    batch_number: batchNumber,
    order_ids: orderIds,
    customer_id: customerId
  }, getAuthHeader());
  return response.data;
};

export const getNextBatchNumber = async () => {
  const response = await axios.get('/api/orders/batches/next_number/', getAuthHeader());
  return response.data.batch_number;
};

export const exportBatch = async (batch) => {
  const response = await axios.get(`/api/orders/batches/${batch.id}/export/`, {
    ...getAuthHeader(),
    responseType: 'blob'
  });
  
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `batch_${batch.batch_number}.xlsx`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export const addOrdersToBatch = async (batchNumber, orderIds, customerId) => {
  const response = await axios.post('/api/orders/batches/bulk/', {
    batch_number: batchNumber,
    order_ids: orderIds,
    customer_id: customerId
  }, getAuthHeader());
  return response.data;
};

export const fetchBatchStatistics = async () => {
  const response = await axios.get('/api/orders/batches/statistics/', getAuthHeader());
  return response.data;
};
